// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class SharedCaseCaseOrderedRelationshipModel {
    'partyRoleId'?: number;
    'isPrimary'?: boolean;
    'coverageOrder'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof SharedCaseCaseOrderedRelationshipModel>> = [
        {
            "name":     "partyRoleId",
            "baseName": "partyRoleId",
            "type":     "number"
        },
        {
            "name":     "isPrimary",
            "baseName": "isPrimary",
            "type":     "boolean"
        },
        {
            "name":     "coverageOrder",
            "baseName": "coverageOrder",
            "type":     "number"
        },
    ];

    static getAttributeTypeMap() {
        return SharedCaseCaseOrderedRelationshipModel.attributeTypeMap;
    }
}
